import axios from "axios";
import store from "../redux/store";
import { resetAllData } from "../redux/actions/userAction";

// initialize axios

export const baseURL = `${process.env.REACT_APP_ENV === "dev" ? process.env.REACT_APP_API_DEV_URL : process.env.REACT_APP_API_BASE_URL}/api/v1/`;

const api = axios.create({
  baseURL: baseURL,
  headers: {
    common: {
      Authorization: `Bearer ${localStorage.getItem("accessToken") ?? ""}`,
    },
  },
  withCredentials: true,
});

// interseptor for session expired
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (err) => {
    if (
        err.response?.data?.error === "Unauthorized" &&
        err.response?.status === 401
    ) {
        localStorage.clear();
        store.reduxStore.dispatch(resetAllData());
    }
    return Promise.reject(err);
  }
);

export default api;
